import Vue from "vue";
import i18n from "@/plugins/i18n";

const AppService = {
    toastSuccess(text) {
        Vue.notify({
            type: 'success',
            title: i18n.t('Success'),
            text: text
        })
    },
    toastError(text) {
        Vue.notify({
            type: 'error',
            title: i18n.t('Error'),
            text: text
        })
    },
    copyToClipboard(str) {
        const el = document.createElement('textarea')
        el.addEventListener('focusin', e => e.stopPropagation())
        el.value = str
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
    }
}
export default AppService
